import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

const AUTH_RETRY = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  if (request.context.get(AUTH_RETRY) || isCredentialRequest(request.url)) return next(request);

  const send = (accessToken: string | null) => {
    const outgoing = accessToken
      ? request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
      : request;
    return next(outgoing).pipe(
      catchError(error => {
        if (!(error instanceof HttpErrorResponse) || error.status !== 401 || !auth.refreshToken()) return throwError(() => error);
        return auth.refreshSession().pipe(
          switchMap(newToken => next(request.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
            context: request.context.set(AUTH_RETRY, true)
          })))
        );
      })
    );
  };

  const token = auth.token();
  if (token && auth.isAccessTokenExpired(token) && auth.refreshToken()) {
    return auth.refreshSession().pipe(switchMap(newToken => send(newToken)));
  }
  return send(token);
};

function isCredentialRequest(url: string): boolean {
  return url.includes('/auth/login') || url.includes('/auth/refresh-token-login') || url.includes('/auth/logout');
}
